"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _choiceShared = require("@ingka/choice-shared");
var _variables = require("@ingka/variables");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function AnimateHeight(_ref) {
  let {
    children,
    className,
    contentClassName,
    expanded,
    duration,
    id,
    ...props
  } = _ref;
  const contentElement = (0, _react.useRef)();
  const animationFrameID = (0, _react.useRef)(null);
  const [animationState, setAnimationState] = (0, _react.useState)(expanded ? _choiceShared.animationStates.STATIC_AUTO : _choiceShared.animationStates.STATIC_ZERO);
  (0, _react.useEffect)(() => {
    cancelAnimationFrame(animationFrameID.current);
    if (animationState === _choiceShared.animationStates.STATIC_AUTO && expanded || animationState === _choiceShared.animationStates.STATIC_ZERO && !expanded) {
      return;
    }
    setAnimationState(expanded ? _choiceShared.animationStates.PREPARE_ANIMATE_FROM_ZERO : _choiceShared.animationStates.PREPARE_ANIMATE_FROM_AUTO);
  }, [expanded]);
  (0, _react.useEffect)(() => {
    if (animationState === _choiceShared.animationStates.PREPARE_ANIMATE_FROM_ZERO) {
      setAnimationState(_choiceShared.animationStates.ANIMATING_TO_AUTO);
    } else if (animationState === _choiceShared.animationStates.PREPARE_ANIMATE_FROM_AUTO) {
      setAnimationState(_choiceShared.animationStates.ANIMATING_TO_ZERO);
    }
  }, [animationState]);
  (0, _react.useEffect)(() => {
    return () => {
      cancelAnimationFrame(animationFrameID.current);
    };
  }, []);
  const isCollapsed = animationState === _choiceShared.animationStates.STATIC_ZERO;
  return _react.default.createElement("div", {
    "aria-labelledby": props['aria-labelledby'],
    "aria-hidden": isCollapsed,
    className: className,
    id: id,
    style: _choiceShared.getStyles[animationState](duration, contentElement.current ? contentElement.current.offsetHeight : null),
    onTransitionEnd: () => setAnimationState(expanded ? _choiceShared.animationStates.STATIC_AUTO : _choiceShared.animationStates.STATIC_ZERO)
  }, _react.default.createElement("div", {
    className: contentClassName,
    style: {
      display: isCollapsed ? 'none' : null
    },
    ref: contentElement
  }, children));
}
AnimateHeight.defaultProps = {
  duration: parseInt(_variables.durationSlowWeb, 10),
  style: {}
};
var _default = AnimateHeight;
exports.default = _default;